import { CUSTOM_CONTENT_AUDIENCE_TYPES } from '@/constants/customContent'

const { CUSTOM, PUBLIC } = CUSTOM_CONTENT_AUDIENCE_TYPES

export function normalizeCustomContentAudienceType(audienceType) {
  return audienceType === CUSTOM ? CUSTOM : PUBLIC
}

export function shouldDisableCustomContentToggle({
  featureEnabled,
  isEditing,
  persistedAudienceType,
}) {
  if (!featureEnabled) return false
  if (!isEditing) return false

  return normalizeCustomContentAudienceType(persistedAudienceType) === PUBLIC
}

export function shouldConfirmCustomToPublicTransition({
  featureEnabled,
  isEditing,
  persistedAudienceType,
  nextIsCustomContentEnabled,
}) {
  if (!featureEnabled) return false
  if (!isEditing) return false
  if (nextIsCustomContentEnabled) return false

  return normalizeCustomContentAudienceType(persistedAudienceType) === CUSTOM
}

export function decorateLatestDialog(
  className,
  { maxWidth = null, normalizeText = false } = {}
) {
  if (typeof document === 'undefined') return
  if (!document.body) return

  const applyDialogStyles = () => {
    const latestDialog = document.body.querySelector('.con-vs-dialog')
    if (!latestDialog) return false

    if (className) {
      latestDialog.classList.add(className)
    }

    const dialogElement = latestDialog.querySelector('.vs-dialog')
    if (dialogElement && maxWidth) {
      dialogElement.style.maxWidth = maxWidth
    }

    const dialogTextElement = latestDialog.querySelector('.vs-dialog-text')
    if (dialogTextElement && normalizeText) {
      // Preserve explicit line breaks in dialog copy while keeping normal spacing.
      dialogTextElement.style.whiteSpace = 'pre-line'
      dialogTextElement.style.marginTop = '0'
      if (typeof dialogTextElement.textContent === 'string') {
        dialogTextElement.textContent = dialogTextElement.textContent.trimStart()
      }
    }

    return true
  }

  applyDialogStyles()

  // Vuesax performs an extra internal tick/render after opening the dialog.
  // Re-apply once more to ensure width and text normalization persist.
  setTimeout(applyDialogStyles, 0)
  setTimeout(applyDialogStyles, 40)
}
